import { defineMessages } from 'react-intl'

const scope = `procurify.modules.reports.features.deleteExportTask.UseDeleteExportTaskPresenter`

// Toast copy matches the live-observed contract (BHV-037).
export default defineMessages({
  successToastTitle: {
    id: `${scope}.successToastTitle`,
    defaultMessage: 'Record removed',
  },
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage:
      'The record has been removed from the requested CSVs history',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastFallbackMessage: {
    id: `${scope}.errorToastFallbackMessage`,
    defaultMessage: "Couldn't remove the record. Please try again",
  },
})
